import type { IVector3 } from '@seddi/math-v2';
import { Vector3 } from '@seddi/three';

export type CameraLookAt = {
  distance: number;
  origin: IVector3;
  target: IVector3;
};

export type BoundingSphere = {
  center: IVector3;
  radius: number;
};

export const create = (): CameraLookAt => {
  return {
    distance: 0,
    origin: { x: 0, y: 0, z: 0 },
    target: { x: 0, y: 0, z: 0 },
  };
};

export const clone = (other: CameraLookAt): CameraLookAt => {
  return {
    distance: other.distance,
    origin: { ...other.origin },
    target: { ...other.target },
  };
};

export const copy = (t: CameraLookAt, other: CameraLookAt) => {
  t.distance = other.distance;
  t.origin.x = other.origin.x;
  t.origin.y = other.origin.y;
  t.origin.z = other.origin.z;
  t.target.x = other.target.x;
  t.target.y = other.target.y;
  t.target.z = other.target.z;
};

export const computeFromBounds = (() => {
  const FOV = 20;
  const RADIUS_SCALE = 1.2;

  const Z = new Vector3(0, 0, 1);
  const eye = new Vector3();
  const target = new Vector3();

  return (bounds: Readonly<BoundingSphere>, screenRatio: number = 1): CameraLookAt => {
    let fov = (FOV * 2 * Math.PI) / 360;
    if (screenRatio < 1) {
      fov *= screenRatio;
    }

    const { center, radius } = bounds;
    const distance = (radius * RADIUS_SCALE) / Math.tan(fov * 0.5);
    target.set(center.x, center.y, center.z);
    eye.copy(Z).multiplyScalar(distance).add(target);

    return {
      distance,
      origin: { x: eye.x, y: eye.y, z: eye.z },
      target: { x: target.x, y: target.y, z: target.z },
    };
  };
})();

